import { render } from "./FileViewerModal.vue?vue&type=template&id=5a869106&scoped=true"
import script from "./FileViewerModal.vue?vue&type=script&lang=js"
export * from "./FileViewerModal.vue?vue&type=script&lang=js"

import "./FileViewerModal.vue?vue&type=style&index=0&id=5a869106&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a869106"]])

export default __exports__